var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 8.5C3.5 7.67157 4.17157 7 5 7H27C27.8284 7 28.5 7.67157 28.5 8.5C28.5 9.32843 27.8284 10 27 10H5C4.17157 10 3.5 9.32843 3.5 8.5Z",
    fill: "url(#paint0_linear_234:190)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 13.5C3.5 12.6716 4.17157 12 5 12H21C21.8284 12 22.5 12.6716 22.5 13.5C22.5 14.3284 21.8284 15 21 15H5C4.17157 15 3.5 14.3284 3.5 13.5Z",
    fill: "url(#paint1_linear_234:190)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.50098 18.5C3.50098 17.6716 4.17255 17 5.00098 17H27.0002C27.8287 17 28.5002 17.6716 28.5002 18.5C28.5002 19.3284 27.8287 20 27.0002 20H5.00098C4.17255 20 3.50098 19.3284 3.50098 18.5Z",
    fill: "url(#paint2_linear_234:190)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.50098 23.5C3.50098 22.6716 4.17255 22 5.00098 22H21.0002C21.8287 22 22.5002 22.6716 22.5002 23.5C22.5002 24.3284 21.8287 25 21.0002 25H5.00098C4.17255 25 3.50098 24.3284 3.50098 23.5Z",
    fill: "url(#paint3_linear_234:190)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_234:190",
    x1: 28.5,
    y1: 10,
    x2: 4.29832,
    y2: 3.85557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72B995"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_234:190",
    x1: 22.5,
    y1: 15,
    x2: 3.62391,
    y2: 11.3578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72B995"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_234:190",
    x1: 28.5002,
    y1: 20,
    x2: 4.29918,
    y2: 13.8559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72B995"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_234:190",
    x1: 22.5002,
    y1: 25,
    x2: 3.62483,
    y2: 21.3581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72B995"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.e1dc992eec1d82d814a80a26d5badc9f.svg";
export { ForwardRef as ReactComponent };